// NOTE: NSAI-7067 — how often the card re-reads the clock while something is
// moving, so "2 min left" counts down between progress events.
export const TRANSFER_POPUP_CLOCK_INTERVAL_MS = 1000;
